import styled from "styled-components";
import { bool, func } from 'prop-types';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos navbar
Description : Se definen los estilos de los elementos de la barra de navegación.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se definen elementos y estilos de la barra de navegación.
2/11/2021 Cristian Andres Pizo Mina – Se agrego cuersor:pointer a Element y Titulo.
================================================================================ */

export const Nav = styled.nav`
    background: #1061a2;
    height: 50px;
    align-items: center;
    display: flex;
    z-index: 100;
    width: 100%;
    @media screen and (max-width: 960px){
        justify-content: right;
    }
`

export const MenuIcon = styled.div`
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
`

export const Icon = styled.i`
    color: #fff;
`

export const Bar = styled.ul`
    grid-template-columns: repeat(3, auto);
    width: 70vw;
    justify-content: end;
    margin-right: -10rem;
    @media screen and (max-width: 960px){
        display: ${({ show }) => show ? 'flex' : 'none'};
        margin-right: 0rem;
        justify-content: center;
        background: #1061a2;
        transform : ${({ show }) => show ? 'translateX(-10)' : 'translateX(200%)'};
        height: 20vh;
        width: 30%;
        text-align: right;
        position: absolute;
        top: 0;
        right: 0;
        transition: transform 0.3s ease-in-out;

        a {
            font-size: 1rem;
            padding: 0.5rem;
            font-weight: bold;
            text-align: end;
            min-height: 5px;
            min-width: 8px;
            justify-content: center;
            text-justify: center;
            color: white;
            border: 2px solid;
            border-color: white;
            border-radius: 4px;
            margin-top: 2px;
            text-decoration: none;
            transition: color 0.3s linear;
            width: 125%;
            display: flex;

            &:hover {
                background-color: #6d76f7;
                border-radius: 4px;
                transition: all 0.2 ease-out;
            }
        }
    }
`
export const Image = styled.img`
    height: 2.5rem;
    width: 7.5rem;
    top: 0;
    left: 0;
    margin-left: 5rem;
    margin-top:0.5rem;
    //margin-top: -5px;
    /* margin-bottom: 5rem; */
    position: absolute;
`

export const Element = styled.a`
    color: #fff;
    text-decoration: none;
    padding: 0.5rem 1rem;
    font-weight: bold;
    border: none;
    cursor: pointer;
    &:hover{
        color: white;
        background-color: #6d76f7;
        border-radius: 4px;
        transition: all 0.2 ease-out;
        text-decoration: none;
    }
    @media screen and (max-width: 960px){
        align-content: end;
    }
`

export const Li = styled.li`
    padding-top: 80 px;
    margin-top: 15px;
    align-self: start;
`

export const Title = styled.a`
    color: white;
    text-decoration: none;
    font-weight: bold;
    margin-left: -550px;
    margin-top: 17px;
    margin-bottom: -90px;
    position: absolute;
    cursor: pointer;
    &:hover{
        color: white;
        background-color: #6d76f7;
        border-radius: 4px;
        transition: all 0.2 ease-out;
        text-decoration: none;
    }
    @media screen and (max-width: 960px){
        width: 50%;
        display: table;
        margin-left: 20px;
        box-sizing: 5px;
        margin-top: 0px;
        justify-content: center;
        &:hover{
            background-color: #7577fa;
            border-radius: 4px;
        }
    }
`

export const Button2 = styled.button`
  display: none;
  @media screen and (max-width: 960px){
    position: absolute;
    top: 5%;
    right: 10;
    display: flex;
    margin-top: 5px;
    flex-direction: column;
    justify-content: space-around;
    right: 0px;
    width: 2rem;
    height: 2rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 10;

    &:focus {
        outline: none;
    }

    &:hover{
        background-color: #7577fa;
        border-radius: 4px;
    }

    div {
        width: 2rem;
        height: 0.25rem;
        background: white;
        border-radius: 10px;
        transition: all 0.3s linear;
        position: static;
        transform-origin: 1px;
        justify-content: end;
    }
  }
`;

Button2.propTypes = {
    show: bool.isRequired,
    setShow: func.isRequired,
}

Bar.propTypes = {
    show: bool.isRequired,
}